import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/jyjczx/中心简介.png';
import _imports_1 from '../assets/page-image/jyjczx/环境.png';
import _imports_2 from '../assets/page-image/jyjczx/电学.png';
const _hoisted_1 = {
  class: "jyjczx-wrapper"
};
const _hoisted_2 = {
  class: "jyjczx-page"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  class: "section"
};
import SectionTitle from '@/components/SectionTitle.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Footer from '@/components/Footer.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Jyjczx',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '技术服务平台'
        }, {
          label: '检验检测中心'
        }]
      }), _createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "page-title"
      }, "检验检测中心", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(SectionTitle, {
        title: "中心简介",
        "show-more": false
      }), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "intro-image"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "中心简介"
      })], -1)), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "intro-text"
      }, [_createElementVNode("p", null, "长春光机所国家光学机械质量监督检验中心设立检验检测服务站,面向非接触光学检测、电子学和环境试验等提供光电系统精密检测技术研究、光机系统测试、环境检测等服务。")], -1))]), _createElementVNode("div", _hoisted_4, [_createVNode(SectionTitle, {
        title: "服务项目",
        "show-more": false
      }), _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"service-section\" data-v-c3b74932><div class=\"service-card\" data-v-c3b74932><div class=\"card-image\" data-v-c3b74932><img src=\"" + _imports_1 + "\" alt=\"环境试验\" data-v-c3b74932></div><div class=\"card-btn\" data-v-c3b74932>环境试验</div></div><div class=\"service-card\" data-v-c3b74932><div class=\"card-image\" data-v-c3b74932><img src=\"" + _imports_2 + "\" alt=\"电学检测/试验\" data-v-c3b74932></div><div class=\"card-btn\" data-v-c3b74932>电学检测/试验</div></div></div>", 1))])]), _createVNode(Footer)]);
    };
  }
});